import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { API_URL } from "..";
const AddPayroll = () => {
  
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:'',
    desc:''
  });
  const [selectDriver, setSelectDriver]= useState([])
  const [selectDriverSelect, setSelectDriverSelect]= useState({})
  const [selectedMonth, setSelectedMonth]= useState({})
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };
React.useEffect(()=>{
  onChangeCompany()
},[1])
const options = [
    { value: 'Jan', label: 'January' },
    { value: 'Feb', label: 'February' },
    { value: 'Mar', label: 'March' },
    { value: 'Apr', label: 'April' },
    { value: 'May', label: 'May' },
    { value: 'Jun', label: 'June' },
    { value: 'Jul', label: 'July' },
    { value: 'Aug', label: 'August' },
    { value: 'Sep', label: 'September' },
    { value: 'Oct', label: 'October' },
    { value: 'Nov', label: 'November' },
    { value: 'Dec', label: 'December' },
  ];
  

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const onFormSubmit = async (event) =>{
    event.preventDefault();


      let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         const getYear = new Date();
         const user = JSON.parse(localStorage.getItem('user'));
         let bodyContent = JSON.stringify({
            "affiliate_id" : user.id,
            "driver_id":selectDriverSelect.value,
            "month_year": selectedMonth.value + '_' +getYear.getFullYear(),
            "total_amount": parseFloat(event.target.elements.total_amount.value),
            "deductions": parseFloat(event.target.elements.deductions.value),
            "fine": parseFloat(event.target.elements.fine.value),
            "payroll_mode": event.target.elements.payout_mode.value,
            "bonuses": parseFloat(event.target.elements.bonuses.value),
            "commission": parseFloat(event.target.elements.commission.value),
            "payout_type": event.target.elements.payout_type.value
         });
         let response = await fetch(API_URL+"/api/payroll/create", { 
           method: "POST",
           body: bodyContent,
           headers: headersList
         });
       let data = await response.json();
       if(response.status == 201){
        setshowAlertMessage({
          message: 'success',
          status:true,
          desc:'Payroll Is added successfully'
        });
        setSelectDriverSelect({})
        setSelectedMonth({})
        event.target.elements.total_amount.value=''
        event.target.elements.deductions.value=''
        event.target.elements.fine.value=''
        event.target.elements.bonuses.value=''
        event.target.elements.commission.value=''
        event.target.elements.payout_type.value=''
       }else{
  
  
        setshowAlertMessage({
          message: 'error',
          status:true,
          desc:'Error while adding new payroll'
        });
       }
    
     
  }

  const onChangeCompany = async ()=>{
    
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
      Accept: "*/*",
      // "User-Agent": "Thunder Client (https://www.thunderclient.com)",
    };
   
    try { 
         const response =  await fetch(`${API_URL}/api/driver/fetch/${user.id}`, {headers:headersList,method : 'GET'});
        const data = await response.json();
        const formattedData = data.data.map((e) => ({
          value: e.id,
          label: e.name
        }));

        setSelectDriver(formattedData)
      
    } catch (error) {
      console.log(error.message)
    }
   
  }
  const handleChangeDriver = (selected) => {
    setSelectDriverSelect(selected || []);
  };
  const handleChangeMonth = (selected) => {
    setSelectedMonth(selected || []);
  };
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Create Payroll" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-8 col-xl-8 col-lg-10">
                <div className=" border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>onFormSubmit(event)}>
                    
                      <div className="row mb-20">
                        <div className="col-md-6">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Select Driver <span className="text-danger-600">*</span>
                        </label>
                        <Select
                            options={selectDriver}
                            
                            value={selectDriverSelect}
                            onChange={handleChangeDriver}
                            placeholder="Select Options"
                        />

                        </div>
                       
                        <div className="col-md-6">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Select Month <span className="text-danger-600">*</span>
                        </label>
                        <Select options={options} value={selectedMonth} placeholder="Select Month" onChange={handleChangeMonth}/>

                        </div>
                       
                      </div>

                      <div className="mb-20">
                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                        Payout Mode <span className="text-danger-600">*</span>
                        </label>
                        
                        <div className="form-check checked-success d-flex align-items-center gap-2">
                         
                        {/* </div>
                        <div className="form-check checked-secondary d-flex align-items-center gap-2"> */}
                            <input
                                className="form-check-input"
                                type="radio"
                                name="payout_mode"
                                value={'hourly'}
                                id="radio"
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="radio"
                            >
                                {" "}
                                Hourly{" "}
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="payout_mode"
                                id="radio2"
                                value={'weekly'}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="radio2"
                            >
                                {" "}
                                Weekly{" "}
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="payout_mode"
                                id="radio1"
                                value={'monthly'}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="radio1"
                            >
                                {" "}
                               Monthly{" "}
                            </label>
                        </div>
                        </div>
                        
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                        Actual Salary <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="number"
                          min={1}
                          name="total_amount"
                          className="form-control radius-8"
                          id="name"
                          
                          placeholder="0.00"
                        />
                      </div>

                      <div className=" pt-20 row">
                        <div className="col-md-6">
                          <h6>Addons</h6>
                          <div className="mb-20">
                                <label
                                htmlFor="name"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                Bonus Amount 
                                </label>
                                <input
                                type="number"
                                min={1}
                                name="bonuses"
                                className="form-control radius-8"
                                id="name"
                                
                                placeholder="0.00"
                                />
                        </div>
                          <div className="mb-20">
                                <label
                                htmlFor="name"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                Commission Amount 
                                </label>
                                <input
                                type="number"
                                min={1}
                                name="commission"
                                className="form-control radius-8"
                                id="name"
                                
                                placeholder="0.00"
                                />
                        </div>

                        </div>
                        <div className="col-md-6">
                          <h6>Deduction</h6>
                          <div className="mb-20">
                                <label
                                htmlFor="name"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                Deduction Amount 
                                </label>
                                <input
                                type="number"
                                min={1}
                                name="deductions"
                                className="form-control radius-8"
                                id="name"
                                
                                placeholder="0.00"
                                />
                        </div>
                          <div className="mb-20">
                                <label
                                htmlFor="name"
                                className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                Fine 
                                </label>
                                <input
                                type="number"
                                min={1}
                                name="fine"
                                className="form-control radius-8"
                                id="name"
                                
                                placeholder="0.00"
                                />
                        </div>

                        </div>
                      </div>
                  
                      <div className="mb-20">
                        <label
                          htmlFor="payout_type"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Select Payout type <span className="text-danger-600">*</span>
                        </label>
                         <select id="payout_type" name="payout_type" className="form-control">
                          <option value={'cash'}>Cash</option>
                          <option value={'bank_transfer'}>Bank Transfer</option>
                         </select>
                      </div>
                      
                      {
                      showAlertMessage.status === true?
                    <div
                        className={
                          showAlertMessage.message == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessage.desc}
                        <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                   
                      <div className="d-flex align-items-end justify-content-center mt-20 gap-3">
                   
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default AddPayroll;
